"use strict";

exports.__esModule = true;
exports.default = useRTGTransitionProps;
var _react = require("react");
var _useMergedRefs = _interopRequireDefault(require("@restart/hooks/useMergedRefs"));
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _excluded = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "addEndListener", "children"];
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
/**
 * Normalizes RTG transition callbacks with nodeRef to better support
 * strict mode.
 *
 * @param props Transition props.
 * @returns Normalized transition props.
 */
function useRTGTransitionProps(_ref) {
  var onEnter = _ref.onEnter,
    onEntering = _ref.onEntering,
    onEntered = _ref.onEntered,
    onExit = _ref.onExit,
    onExiting = _ref.onExiting,
    onExited = _ref.onExited,
    addEndListener = _ref.addEndListener,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var nodeRef = (0, _react.useRef)(null);
  var mergedRef = (0, _useMergedRefs.default)(nodeRef, (0, _utils.getChildRef)(children));
  var normalize = function normalize(callback) {
    return function (param) {
      if (callback && nodeRef.current) {
        callback(nodeRef.current, param);
      }
    };
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  var handleEnter = (0, _react.useCallback)(normalize(onEnter), [onEnter]);
  var handleEntering = (0, _react.useCallback)(normalize(onEntering), [onEntering]);
  var handleEntered = (0, _react.useCallback)(normalize(onEntered), [onEntered]);
  var handleExit = (0, _react.useCallback)(normalize(onExit), [onExit]);
  var handleExiting = (0, _react.useCallback)(normalize(onExiting), [onExiting]);
  var handleExited = (0, _react.useCallback)(normalize(onExited), [onExited]);
  var handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return Object.assign({}, props, {
    nodeRef: nodeRef
  }, onEnter && {
    onEnter: handleEnter
  }, onEntering && {
    onEntering: handleEntering
  }, onEntered && {
    onEntered: handleEntered
  }, onExit && {
    onExit: handleExit
  }, onExiting && {
    onExiting: handleExiting
  }, onExited && {
    onExited: handleExited
  }, addEndListener && {
    addEndListener: handleAddEndListener
  }, {
    children: typeof children === 'function' ? function (status, innerProps) {
      return (
        // TODO: Types for RTG missing innerProps, so need to cast.
        children(status, Object.assign({}, innerProps, {
          ref: mergedRef
        }))
      );
    } : /*#__PURE__*/(0, _react.cloneElement)(children, {
      ref: mergedRef
    })
  });
}